module.exports = __webpack_public_path__ + "static/img/1.ccb8599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/video-group/1.jpg
// module id = UBgU
// module chunks = 1